import type { SerializedStyles } from '@emotion/react';
import { Icon } from '@hotjar/webapp/components/Icon';
import { css } from '@emotion/react';

interface CircleIconProps {
  size: number;
  backgroundColor: string;
  color: string;
  icon: string;
  css?: SerializedStyles | SerializedStyles[];
}

export const CircleIcon = ({
  size,
  backgroundColor,
  color,
  icon,
  ...props
}: CircleIconProps): JSX.Element => {
  const padding = 2;
  return (
    <Icon
      css={css`
        background-color: ${backgroundColor};
        border-radius: 50%;
        padding: ${padding}px;
      `}
      size={size - 2 * padding}
      color={color}
      icon={icon}
      {...props}
    />
  );
};
